import { useEffect, useRef } from "react"
import { emit, EVENTS } from "../event-emitter"
import { extractText } from "../utils"

/**
 * Emits telemetry when the modal is mounted or unmounted.
 *
 * @param {Object} props - Data to send alongside the event.
 */
export function useModalTelemetry(props) {
  const enabled = useRef(props.telemetry !== false)
  const data = useRef(props)

  useEffect(() => {
    data.current = props
  }, [props])

  useEffect(() => {
    if (!enabled.current) return

    const flattenedData = () => ({
      label: extractText(data.current.label),
      ariaLabel: extractText(data.current.ariaLabel),
      ...data.current.telemetry
    })

    emit(EVENTS.MODAL_OPEN, flattenedData())

    return () => {
      emit(EVENTS.MODAL_CLOSE, flattenedData())
    }
  }, [])
}
